"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DailyDecadePeriodizer = void 0;
const constants_1 = require("../../../../constants");
const sharedTypes_1 = require("../sharedTypes");
const DimensionedPeriodizer_1 = require("./DimensionedPeriodizer");
const util_1 = require("../../../../util");
const debug = util_1.DEBUG_OVERRIDE || (util_1.NOT_LAMBDA && false);
const className = 'DailyDecadePeriodizer';
/**
 * @class QuarterHourPeriodizer manages periodization for 1 month of quarter hour peridos
 */
class DailyDecadePeriodizer extends DimensionedPeriodizer_1.DimensionedPeriodizer {
    constructor(ob) {
        super(ob);
        this.timeBucketDefinition = {
            unit: util_1.TimeBucketUnits.DAY,
            width: 1,
        };
        this.timeBucketToAccessor = (timeBucketAccessor) => {
            const [y, m, d, h, min, s] = timeBucketAccessor;
            const thisAccessor = [y % 10, m, (d - 1)];
            return thisAccessor;
        };
        this.periodizerDaysLength = () => (0, util_1.daysInLastUTCDecade)(this.lastUpdatedTimestamp ?? 0);
        this.getFirstPossibleTimestamp = () => (this.lastUpdatedTimestamp ?? 0) - this.periodizerDaysLength() * constants_1.Milliseconds.DAY + 1 * constants_1.Milliseconds.DAY;
        this.accessorToTimestamp = (accessor) => {
            const decadeOffset = Math.floor(new Date(this.lastUpdatedTimestamp ?? 0).getUTCFullYear() / 10) * 10;
            const baseDate = new Date();
            baseDate.setUTCFullYear(decadeOffset + accessor[0], accessor[1], accessor[2] + 1);
            const impliedTimestamp = baseDate.valueOf();
            return impliedTimestamp;
        };
        /**
         * @deprecated
         * @function accessorToTimestampParked for unknown reason gives bad future dates which don't correctly deal with leap years
         * @param accessor
         * @returns
         */
        this.accessorToTimestampParked = (accessor) => {
            const startTimestamp = this.lastUpdatedTimestamp ?? 0;
            const currentAccessor = this.timestampToAccessor(startTimestamp);
            const [_yearDiff, _monthsDiff, daysDiff] = accessor.map((v, i) => v - currentAccessor[i]);
            // handle rollover by when days same hour same quarter more, days same hour more, days more
            let absoluteNegativeDiff;
            const [currentDYear, currentMonth] = currentAccessor; // probably need just on on this or lastUpdatedTimestamp for year
            const [accessorDYear, accessorMonth] = accessor;
            const decadeOffset = Math.floor(new Date(this.lastUpdatedTimestamp ?? 0).getUTCFullYear() / 10) * 10;
            console.log('decardOffset', decadeOffset);
            const accessorYear = decadeOffset + accessorDYear;
            const currentYear = decadeOffset + currentDYear;
            const monthDaysDiffRes = (0, util_1.monthDiffYearsDaysDiff)(accessorYear, accessorMonth, currentYear, currentMonth);
            const relativeDiffDays = monthDaysDiffRes + daysDiff;
            const relativeDiff = relativeDiffDays * constants_1.Milliseconds.DAY;
            debug && console.log({ monthDaysDiffRes, daysDiff, relativeDiffDays });
            if (relativeDiff > 0) {
                // absolute diff A + B is length of bucket minus how far ahead the accessor is xxxxx  [<---A---xxxxx--B-->]
                absoluteNegativeDiff = -(this.periodizerDaysLength() * constants_1.Milliseconds.DAY - relativeDiff);
            }
            else {
                absoluteNegativeDiff = relativeDiff;
            }
            const impliedTimestamp = startTimestamp + absoluteNegativeDiff;
            // if ( accessor.every( ( v, i) => v === 0 ) ) { console.log({ accessor, currentAccessor, _monthsDiff, daysDiff, hoursDiff, monthDaysDiffRes, relativeDiff, impliedTimestamp, date: new Date(impliedTimestamp).toUTCString() }) }
            return impliedTimestamp;
        };
        this.isValidAccessor = (args) => {
            const date = new Date(this.lastUpdatedTimestamp ?? 0);
            const currentYear = date.getUTCFullYear();
            const diff = args[0] - (currentYear % 10);
            date.setUTCFullYear(currentYear + diff, args[1], 1);
            const maxDays = (0, util_1.daysInThisUTCMonth)(date.valueOf());
            //debug && console.log(`In current year ${ currentYear } with diff ${ diff } max days for ${ args.join()}, ${maxDays} using ${date.toUTCString()}`)
            const isValid = args.length === this.arrayLengths?.length && args.every((d, i) => d >= 0) && args[1] <= 11 && args[2] <= maxDays - 1;
            if (!isValid) {
                debug && console.log(`Not valid accessor`, args);
            }
            debug && console.log({ accessor: args, maxDays, isValid, date: date.toUTCString() });
            return isValid;
        };
        if (!ob) {
            this.type = className;
            this.arrayLengths = sharedTypes_1.DailyDecadeBasedArrayDef;
            this.initialize();
        }
    }
}
exports.DailyDecadePeriodizer = DailyDecadePeriodizer;
